import request from '@/utils/request'

// 新增客户留言记录
export function messageSubmit(data) {
  return request({
    url: '/website/message',
    method: 'post',
    data
  })
}